package utils

@Suppress("NOTHING_TO_INLINE")
inline fun printLog(message: String){
    println("[PA] $message")
}